import React from 'react'

const ShortCard = ({data, onClick = (e) => {}}) => {
  return (
    <React.Fragment>
      <div
        className="relative w-[162px] h-auto overflow-hidden cursor-pointer"
        onClick={onClick}
      >
        <img className="w-full" src={data?.image} alt={data?.name} />
        <div className="text-xs py-2 text-center">{data?.label}</div>
      </div>
    </React.Fragment>
  );
}

export default ShortCard